import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';

import {TranslateService} from '@ngx-translate/core';

import {AccountService} from '@core/ecv-http-services/services/account.service';
import {CvsModel} from '../cvs/cvs.model';
import {CvsUtils} from '../cvs/cvs.utils';
import {AlertService} from '@widgets/alert/alert.service';
import {ChangePasswordModel} from './change-password.model';
import {PersonalDetailsModel} from './personal-details.model';
import {ValidatorService} from '@core/validator/validator.service';
import {CustomValidators} from '@core/validator/custom-validators';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';
import {AlertUtils} from '@widgets/../shared/AlertUtils';


@Component({
  selector: 'app-account',
  templateUrl: './account.component.html'
})
export class AccountComponent implements OnInit {

  passwordForm: FormGroup;
  newPasswordForm: FormGroup;
  personalDetailsForm: FormGroup;
  personalDetails: PersonalDetailsModel;
  changePasswordModel: ChangePasswordModel;
  newPasswordConfirmation: string;

  constructor(private accountService: AccountService,
              private validatorService: ValidatorService,
              private translateService: TranslateService,
              private alertService: AlertService,
              private spinnerService: Ng4LoadingSpinnerService) {
    this.personalDetails = new PersonalDetailsModel();
  }

  ngOnInit() {
    this.changePasswordModel = new ChangePasswordModel();
    this.loadPersonalDetails();
    this.createPasswordForm();
    this.createPersonalDetailsForm();
  }

  public uploadCv(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        const fileTypes = ['pdf', 'doc', 'docx'];
        const fileNameParts = file.name.split('.');
        const fileNameExtension = fileNameParts.pop();
        if (fileNameParts.length === 0 || fileNameParts[0].length === 0) {
          AlertUtils.showAlert(false, 'ALERT.FILE_CV_INVALID_FORMAT', this.translateService, this.alertService);
          return;
        }
        if (fileTypes.indexOf(fileNameExtension.toLowerCase()) === -1) {
          AlertUtils.showAlert(false, 'ALERT.FILE_CV_INVALID_FORMAT', this.translateService, this.alertService);
          return;
        }
        if (file.size >= CvsUtils.maxCvSize) {
          AlertUtils.showAlert(false, 'ALERT.FILE_CV_TOO_LARGE', this.translateService, this.alertService);
          return;
        }
        if (file.name.length > CvsUtils.maxCvFilenameLength) {
          AlertUtils.showAlert(false, 'ALERT.FILE_CV_NAME_TOO_LONG', this.translateService, this.alertService);
          return;
        }
        reader.readAsDataURL(file);
        reader.onload = () => {
          const cv = new CvsModel();
          cv.content = reader.result.split(',')[1];
          cv.fileName = file.name;
          this.spinnerService.show();
          this.accountService.uploadCv(cv).subscribe(
            response => {
              this.spinnerService.hide();
              AlertUtils.showAlert(true, 'ALERT.CV_UPLOADED', this.translateService, this.alertService);
            }, responseError => {
              this.spinnerService.hide();
            });
        };
      }
    }
  }

  public changePassword() {
    this.validatorService.validate(this.passwordForm);
    if (!this.validatorService.isValid(this.passwordForm)) {
      return false;
    }

    this.accountService.changePassword(this.changePasswordModel).subscribe(
      response => {
        AlertUtils.showAlert(true, 'ALERT.PASSWORD_CHANGED', this.translateService, this.alertService);
        this.clearPasswordForm();
        this.createPasswordForm();
      });
  }

  private loadPersonalDetails() {
    this.accountService.getPersonalDetails().subscribe(
      response => {
        this.personalDetails = response;
      });
  }

  private clearPasswordForm() {
    this.changePasswordModel = new ChangePasswordModel();
    this.newPasswordConfirmation = undefined;
  }

  private createPasswordForm(): void {
    this.newPasswordForm = new FormGroup({
      'newPassword': new FormControl('', [Validators.required, Validators.minLength(5), CustomValidators.validateNewPassword]),
      'newPasswordConfirmation': new FormControl('', [Validators.required, Validators.minLength(5)])
    }, CustomValidators.validateNewPasswordWithConfirmationPassword('newPassword', 'newPasswordConfirmation'));
    this.passwordForm = new FormGroup({
      'oldPassword': new FormControl('', Validators.required),
      'newPassword': this.newPasswordForm
    });
  }

  private createPersonalDetailsForm(): void {
    this.personalDetailsForm = new FormGroup({
      'firstName': new FormControl(''),
      'lastName': new FormControl('')
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/account/account.component.ts